import React from "react";
import { Link, useLocation } from "react-router-dom";

const serviceAreas = [
  { label: "Etimesgut Koltuk Yıkama", path: "/etimesgut/etimesgut-koltuk-yikama" },
  { label: "Etimesgut Yorgan Yıkama", path: "/etimesgut/etimesgut-yorgan-yikama" },
  { label: "Etimesgut Battaniye Yıkama", path: "/etimesgut/etimesgut-battaniye-yikama" },
  { label: "Etimesgut Kuru Temizleme", path: "/etimesgut/etimesgut-kuru-temizleme" },
  { label: "Etimesgut Perde Yıkama", path: "/etimesgut/etimesgut-perde-yikama" },
  { label: "Etimesgut Yerinde Yıkama", path: "/etimesgut/etimesgut-yerinde-yikama" },
  { label: "Etimesgut Yatak Yıkama", path: "/etimesgut/etimesgut-yatak-yikama" },
  { label: "Eryaman Koltuk Yıkama", path: "/etimesgut/eryaman-koltuk-yikama" },
  { label: "Eryaman Yorgan Yıkama", path: "/etimesgut/eryaman-yorgan-yikama" },
  { label: "Eryaman Perde  Yıkama", path: "/etimesgut/eryaman-perde-yikama" },
  { label: "Bağlıca Koltuk Yıkama", path: "/etimesgut/baglica-koltuk-yikama" },
  { label: "Bağlıca Yorgan Yıkama", path: "/etimesgut/baglica-yorgan-yikama" },
  { label: "Bağlıca Perde Yıkama", path: "/etimesgut/baglica-perde-yikama" },
  { label: "Elvankent Koltuk Yıkama", path: "/etimesgut/elvankent-koltuk-yikama" },
  { label: "Elvankent Yorgan Yıkama", path: "/etimesgut/elvankent-yorgan-yikama" },
  { label: "Elvankent Perde Yıkama", path: "/etimesgut/elvankent-perde-yikama" },
  
];

const EtimesgutServiceArea = () => {
  const location = useLocation();

  return (
     <div className="text-[#003132] mt-0 w-full">
       <h2 className="text-lg font-semibold mb-1 uppercase tracking-wide text-center">ETİMESGUT HİZMET TÜRLERİ</h2>
 
       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full">
         {serviceAreas.map((area, index) => (
           <Link
             key={index}
             to={area.path}
             className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
               location.pathname === area.path
                 ? "bg-green-700 text-white"
                 : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
             }`}
           >
             {area.label}
           </Link>
         ))}
       </div>
     </div>
   );
 };

export default EtimesgutServiceArea;
